const preferredDefault = 'gemini:gemini-2.5-flash';
const providers = new Set(['openai', 'gemini', 'deepseek']);

// The server resolves availability and pricing for the selected usage mode.
// Keep disabled models visible so a Free/Paid restriction has an explanation.
export function medicineDraftModels(catalogue, preferred) {
  if (!catalogue) return { catalogue: null, selection: '', ready: false };
  const models = (catalogue.models || []).filter(model => providers.has(model.provider));
  const selected = models.find(model => model.id === preferred && model.enabled)
    || models.find(model => model.id === catalogue.defaultSelection && model.enabled)
    || models.find(model => model.id === preferredDefault && model.enabled)
    || models.find(model => model.enabled)
    || models.find(model => model.id === preferred)
    || models.find(model => model.id === catalogue.defaultSelection)
    || models.find(model => model.id === preferredDefault)
    || models[0];
  return {
    catalogue: { ...catalogue, models, providers: (catalogue.providers || []).filter(provider => providers.has(provider.id)) },
    selection: selected?.id || '',
    ready: Boolean(selected?.enabled),
  };
}
